import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProjectIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 20,
	viewBox: "0 0 26 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4992 8.75L9.32422 11.325L6.74922 12.5L9.32422 13.675L10.4992 16.25L11.6742 13.675L14.2492 12.5L11.6742 11.325L10.4992 8.75ZM20.5117 0L23.0117 5H19.2617L16.7617 0H14.2617L16.7617 5H13.0117L10.5117 0H8.01172L10.5117 5H6.76172L4.26172 0H3.01172C1.63672 0 0.524219 1.125 0.524219 2.5L0.511719 17.5C0.511719 18.875 1.63672 20 3.01172 20H23.0117C24.3867 20 25.4992 18.875 25.4992 17.5V0H20.5117ZM23.0117 17.5H3.01172V3.0875L5.21172 7.5H17.9992L17.2117 9.2125L15.4992 10L17.2117 10.7875L17.9992 12.5L18.7867 10.7875L20.4992 10L18.7867 9.2125L17.9992 7.5H23.0117V17.5Z",
		fill: "#5E6068"
	})
});
export { SvgProjectIcon as ReactComponent };
